/**
 * This service serves as an interface how a real BookmarkService should be implemented! Do not use in Production!
 */
angular.module('Itao.IndicatorMap').factory('BookmarkService', function($q){
  'use strict';
  return {

    /**
     * Creates a new bookmark
     * @param {String} title Title of the bookmark
     * @param {Integer} categoryId Id of the bookmark's category
     * @param {Object} config Configuration object of the app's state
     * @returns {Promise}
     */
    createBookmark: function (title, categoryId, config) {
      var deferred = $q.defer();
      deferred.resolve({
        id: Math.random() * 1000,
        title: title,
        uri: location.href,
        category: categoryId,
        config: JSON.stringify(config)
      });
      return deferred.promise;
    },

    /**
     * Deletes a bookmark by its id
     * @param {Integer} bookmarkId bookmark's id
     * @returns {Promise}
     */
    deleteBookmark: function(bookmarkId) {
      var deferred = $q.defer();
      deferred.resolve(true);
      return deferred.promise;
    }
  };

});
